import React from "react";
import { useTranslation } from "react-i18next";
import { FlatList, View } from "react-native";

import { renderIndividualCard } from "@/utils/management/RenderObject";

interface IndividualsProps {
  data: any;
}

export default function Individuals(props: IndividualsProps) {
  const { t } = useTranslation();

  return (
    <View className="w-full items-center">
      <FlatList
        className="w-full px-4 lg:px-0 flex-col lg:items-center"
        data={props.data}
        renderItem={({ item, index }) => renderIndividualCard(item, index, t)}
        keyExtractor={(item) => item.id}
      />
    </View>
  );
}
